import Axios from '@/store/axios'
var Promise = require('bluebird')

  const initialState = () => ({
    credit_card: null
  });

  const state = initialState();
  const getters = {
    first_name: (state) => {
      if(state.credit_card == null)
        return null
      else
        return state.credit_card.first_name.charAt(0).toUpperCase() + state.credit_card.first_name.slice(1);
    },
    last_name: (state) => {
      if(state.credit_card == null)
        return null
      else
        return state.credit_card.last_name.charAt(0).toUpperCase() + state.credit_card.last_name.slice(1);
    },
    cardholder: (state, getters) => {
      return getters.first_name + ' ' + getters.last_name
    },
    expiration_display_format: (state) => {
      if(state.credit_card == null)
        return null
      else
        return state.credit_card.expiration.slice(-2) + '/' + state.credit_card.expiration.slice(2,4);
    },
    expiration_year: (state) => {
      if(state.credit_card == null)
        return null
      else
        return state.credit_card.expiration.slice(0,4)
    },
    expiration_month: (state) => {
      if(state.credit_card == null)
        return null
      else
        return state.credit_card.expiration.slice(-2)
    },
    is_card_expired: (state, getters) => {
      if(state.credit_card == null)
        return null
      else {
        var card_date = new Date( getters.expiration_year, getters.expiration_month )
        if(card_date < Date.now())
          return true
        else
          return false
      }
    },
    get_type: (state) => {
      if(state.credit_card == null)
        return null
      else
        return state.credit_card.type == 'mc' ? 'mastercard' : 'visa'
    },
    address: (state) => {
      if(state.credit_card == null)
        return null
      else
        return state.credit_card.address1
    },
    card_billing_address: (state) => {
      let billing_address = {}
      billing_address.address1 = state.credit_card.address1;
      billing_address.city = state.credit_card.city;
      billing_address.state = state.credit_card.state;
      billing_address.zip = state.credit_card.zip;
      billing_address.country = state.credit_card.country;
      return billing_address
    }
  }
  const mutations = {
    DELETE_CREDIT_CARD : (state) => {
      state.credit_card = null;
    },
    SET_CREDIT_CARD : (state, credit_card) => {
      state.credit_card = credit_card;
    },
    RESET: (state) => {
      const newState = initialState();
      Object.keys(newState).forEach( key => {
        state[key] = newState[key]
      });
    }
  }
  const actions = {
    CREATE_CREDIT_CARD : ( context, credit_card ) => {
      return Promise.try( () => {
        // check if credit_card already exists - we only allow one credit card on file
        return context.dispatch('GET_CREDIT_CARD')
      }).then( () => {
        if(context.state.credit_card != null)
          throw new Error('credit card already exists')
        return
      }).then( () => {
        return Axios.post(`billing/credit_card`, credit_card)
      }).then( (account_number) => {
        if(account_number.data.errors) {
          if(account_number.data.errors.number.valid == "The card number given is invalid.") {
            // if we somehow missed the CC number matching above, Blesta will return its own error - we check for that here
            throw new Error('invalid card type')
          }
        }
        // account_number is returned by the endpoint which we may use in the future to get a single credit card instead of all of them when updating
        return context.dispatch('GET_CREDIT_CARD')
      })
    },
    GET_CREDIT_CARD : ( context ) => {
      return Promise.try( () => {
        return Axios.get(`billing/credit_card`)
      }).then( (credit_card) => {
        if(credit_card.status == 200)
          context.commit('SET_CREDIT_CARD', credit_card.data);
        else
          context.commit('SET_CREDIT_CARD', null);
        return
      })
    },
    EDIT_CREDIT_CARD : ( context, credit_card ) => {
      return Promise.try( () => {
        if(!context.state.credit_card.id)
          throw new Error('no card exists')
        else
          return Axios.patch(`billing/credit_card/${context.state.credit_card.id}`, credit_card)
      }).then( () => {
        return context.dispatch('GET_CREDIT_CARD')
      })
    },
    DELETE_CREDIT_CARD : ( context ) => {
      return Promise.try( () => {
        return Axios.delete(`billing/credit_card/${context.state.credit_card.id}`)
      }).then( (response) => {
        context.commit('DELETE_CREDIT_CARD');
        return
      })
    },
  }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
